import {useIntl} from 'react-intl';
import classNames from 'classnames';
import {confirm as luffyConfirm} from '@baidu/luffy-comp-dialog';
import Dialog, {DialogProps} from '../Dialog';
import Button, {ButtonType, ButtonColor, ButtonSize} from '../Button';
import styles from './index.module.scss';
export interface ConfirmDialogProps extends DialogProps {
    confirmDisabled?: boolean;
    confirmColor?: ButtonColor;
    ButtonClassName?: string;
    showCancelButton?: boolean;
    confirmLoading?: boolean;
}


export default function ConfirmDialog(props: ConfirmDialogProps) {

    const intl = useIntl();
    const {
        confirmDisabled = false,
        confirmColor = ButtonColor.Normal,
        confirmLabel, cancelLabel,
        onConfirm, onCancel,
        className,
        children,
        ButtonClassName,
        showCancelButton = true,
        confirmLoading = false,
        ...dialogProps
    } = props;
    const buttonSize = ButtonSize.MD;
    const confirmText = confirmLabel || intl.formatMessage({id: 'commonEnter'});
    const cancelText = cancelLabel || intl.formatMessage({id: 'commonCancel'});

    const dialogClassName = classNames(styles.root, className);

    return (
        <Dialog
            className={dialogClassName}
            actions={
                <div>
                    {
                        showCancelButton && <Button
                            type={ButtonType.Plain}
                            border
                            shape="capsule"
                            size={buttonSize}
                            onClick={onCancel}
                            className={ButtonClassName}
                        >{cancelText}</Button>
                    }
                    <Button
                        noMinWidth
                        type={ButtonType.Important}
                        shape="capsule"
                        color={confirmColor}
                        size={buttonSize}
                        disabled={confirmDisabled}
                        onClick={onConfirm}
                        className={ButtonClassName}
                        loading={confirmLoading}
                    >{confirmText}</Button>
                </div>
            }
            onCancel={onCancel}
            {...dialogProps}
        >
            {children}
        </Dialog>
    );
}

// 暂时给rteToken重试使用 其他情况需扩展
export function confirm({
    message,
    onConfirm,
}: {
    message: string;
    onConfirm: () => void;
}) {
    luffyConfirm({
        className: 'wiki-confirm-modal',
        message: <div className={'wiki-confirm-modal-inner'}>
            <p>{message}</p>
            <div className={'wiki-confirm-action'}>
                <Button
                    noMinWidth
                    type={ButtonType.Important}
                    shape="capsule"
                    onClick={onConfirm}
                >确定</Button>
            </div>
        </div>,
    });
}
